import React from 'react';
import {
  usePlayerStore,
  useExamSessionStore,
  getStore,
} from '../../../stores/StoreContext';
import { View, Text } from '@smarterservices/smarter-ui';
import { Pill, Tooltip } from '@instructure/ui';
import { formatTime } from '../../../helpers/utilities';
import CONSTANTS from '../../../config/constants';
const PlaybarTimer = () => {
  const PlayerStore = getStore('playerStore');
  const isLive = usePlayerStore((state) => state.isLive);
  const recordingStatus = useExamSessionStore((state) => state.recordingStatus);

  /**
   * This function displays the time of the video in the player's control bar.
   * If the video is live, it displays "Live" followed by the length of the active session.
   * If the video is not live, it displays the current time and the duration of the video.
   * This is done this way so we can limit the re-renders to the most minimal amount of the dom
   * @function
   * @return {string} A string representing the time of the video.
   */
  const getDisplayText = () => {
    const activeSessionTime = usePlayerStore(
      (state) => state.activeSessionTime
    );
    const duration = usePlayerStore((state) => state.duration);
    const currentTime = usePlayerStore((state) => state.currentTime);
    let text = "";
    if (isLive) {
      text = `Live ${activeSessionTime ? '/ ' + formatTime(activeSessionTime) : ''}`;
    } else {
      text = `${formatTime(currentTime)} / ${formatTime(duration)}`;
    }

    return <Text
      size="legend"
      themeOverride={{
        legend: '0.65rem'
      }}>{text}</Text>;

  };

  const renderToolTip = () => {
    return `The end of the recorded video is ${PlayerStore.secondsBehindLive} seconds behind live.`;
  };

  return (
    <View as="div" width="110px" display="inline-block" textAlign="center">
      {isLive ? (
        <Pill color="success"
          themeOverride={(theme) => {
            return {
              background: theme.successColor,
              successColor: 'white'
            };
          }}>
          {getDisplayText()}
        </Pill>
      ) : (
        <>
          {recordingStatus === CONSTANTS.RECORDING_STATUS.COMPLETE ? (
            <Pill color="warning">
              {getDisplayText()}
            </Pill>
          ) : (
            <Tooltip renderTip={() => renderToolTip()}>
              <Pill color="warning" themeOverride={(theme) => {
                return {
                  background: theme.dangerColor,
                  warningColor: 'white'
                };
              }}>
                {getDisplayText()}
              </Pill>
            </Tooltip>
          )}
        </>
      )
      }
    </View >
  );
};

export default PlaybarTimer;
